import { api } from './client';

export const trainingPreferencesAPI = {
  get: (athleteId) => api.get(`/training-preferences/${athleteId}/`),
  create: (data) => api.post('/training-preferences/', data),
};

export const planAPI = {
  get: (athleteId, weekOffset = 0) =>
    api.get(`/generate-week/?athlete_id=${athleteId}&week_offset=${weekOffset}`),
  generate: (athleteId, weekOffset = 0, extraRestWeekdays = []) =>
    api.post('/generate-week/', {
      athlete_id: athleteId,
      week_offset: weekOffset,
      extra_rest_weekdays: extraRestWeekdays,
    }),
};

export const notificationsAPI = {
  save: (data) => api.post('/notification-settings/', data),
};

export const todayWeatherAdjustmentAPI = {
  get: (athleteId, lat, lng) =>
    api.get('/today-weather-adjustment/', { params: { athlete_id: athleteId, lat, lng } }),
};